import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getcapcolorDropDownSlice = createSlice({
    name: 'ownercap',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchcapcolordropdown.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchcapcolordropdown.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchcapcolordropdown.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setEquipment, setStatus } = getcapcolorDropDownSlice.actions;
export default getcapcolorDropDownSlice.reducer;

export const fetchcapcolordropdown = createAsyncThunk('/GetSilkCapOfOwner/fetch', async ({ ownerid }) => {
    const res = await axios.get(`${window.env.API_URL}/GetSilkCapOfOwner/${ownerid}?size=800`);
    const equipmentData = res.data;
    return equipmentData.data;
})